<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <transition :name="transitionName" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>
<script setup>

import { watch, ref, nextTick,getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
//监听路由变化切换过渡效果
const transitionName = ref("");
//获取挂载的原型方法
const currentInstance = getCurrentInstance() 
const {$zh_tran} = currentInstance.appContext.config.globalProperties 
watch(
  () => {
    return router.currentRoute.value;
  },
  (newValue, oldValue) => {
    // console.log("newValue", newValue);
    // console.log("oldValue", oldValue);
    nextTick(()=>{
      $zh_tran(localStorage.getItem('lang'))
    })
    if (
      (newValue.fullPath == "/home" && oldValue.fullPath == "/loading") ||
      (newValue.fullPath == "/loading" && oldValue.fullPath == "/") ||
      (newValue.fullPath == "/jianjie" && oldValue.fullPath == "/home")
    ) {
      transitionName.value = "fade";
    } else if (
      (newValue.fullPath == "/home" && oldValue.fullPath == "/huiben/one") ||
      (newValue.fullPath == "/home" && oldValue.fullPath == "/huiben/two") ||
      (newValue.fullPath == "/home" && oldValue.fullPath == "/huiben/three") ||
      (newValue.fullPath == "/home" && oldValue.fullPath == "/huiben/four") ||
      (newValue.fullPath == "/home" && oldValue.fullPath == "/huiben/five") ||
      (newValue.fullPath == "/home" && oldValue.fullPath == "/huiben/six") ||
      (newValue.fullPath == "/home" && oldValue.fullPath == "/jianjie") ||
      (newValue.fullPath == "/home" && oldValue.fullPath == "/xiazai")
    ) {
      transitionName.value = "foot";
    } else {
      transitionName.value = "";
    }
  },
  // { immediate: true }
);

</script>
<style lang="scss">
#app {
  height: 100%;
}
body {
  overflow: hidden;
}
body,
html {
  height: 100%;
}
* {
  margin: 0;
  padding: 0;
}
.fade-enter-from,
.fade-leave-to {
  /*定义进入开始和离开结束的透明度为0*/
  opacity: 0;
}
.fade-leave-to {
  transform: translateY(-100%);
}
// .fade-enter-to {
//   transform: translateX(-100%);
// }
.fade-enter-to,
.fade-leave-from {
  /*定义进入结束和离开开始的透明度为1*/
  opacity: 1;
}
.fade-leave-active,
.fade-enter-active {
  transition: all 1s ease-out;
}

.foot-enter-from,
.foot-leave-to {
  /*定义进入开始和离开结束的透明度为0*/
  opacity: 0;
}
.foot-leave-to {
  transform: translateY(100%);
}
// .foot-enter-to {
//   transform: translateX(-100%);
// }
.foot-enter-to,
.foot-leave-from {
  /*定义进入结束和离开开始的透明度为1*/
  opacity: 1;
}
.foot-leave-active,
.foot-enter-active {
  transition: all 1s ease-out;
}

.left-enter-from,
.left-leave-to {
  /*定义进入开始和离开结束的透明度为0*/
  opacity: 0.5;
}
.left-leave-to {
  transform: translateX(-100%);
}
// .left-enter-to {
//   transform: translateX(-100%);
// }
.left-enter-to,
.left-leave-from {
  /*定义进入结束和离开开始的透明度为1*/
  opacity: 1;
}
.left-leave-active,
.left-enter-active {
  transition: all 0.5s ease-out;
}

.right-enter-from,
.left-leave-to {
  /*定义进入开始和离开结束的透明度为0*/
  opacity: 0.5;
}
.right-leave-to {
  transform: translateX(100%);
}
// .left-enter-to {
//   transform: translateX(-100%);
// }
.right-enter-to,
.right-leave-from {
  /*定义进入结束和离开开始的透明度为1*/
  opacity: 1;
}
.right-leave-active,
.right-enter-active {
  transition: all 0.5s ease-out;
}
</style>
